import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material'

export const StyledFormAccordion = styled(Accordion)`
  background-color: transparent;
  border-radius: 0 !important;
  box-shadow: none;
  margin: 0;

  &.Mui-expanded {
    margin: 0;
  }
  
  &.MuiPaper-root::before {
    opacity: 1 !important;
  }
`

export const StyledFormAccordionSummary = styled(AccordionSummary)`
  cursor: pointer;
  padding: 0;
  
  &.MuiAccordionSummary-root {
    min-height: ${({ theme }) => theme.typography.pxToRem(32)} !important;
    background-color: transparent;
    top: 0;
    z-index: 1;
  }

  & .MuiAccordionSummary-content {
    margin: 0 !important;
  }
`

export const StyledFormAccordionDetails = styled(AccordionDetails)`
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
`
